import React from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useRouteName from "../../hooks/useRouteName.js";
import useUserAgent from "../../hooks/useUserAgent.js";
const BOTTOM_NAV_PAGE_LIST = ["home", "searchresults", "searchresults-outbound", "searchresults-inbound"];
export default function BottomNav() {
    const routeName = useRouteName();
    const { isMobile, isWebview } = useUserAgent();
    const pageRole = routeName === "home" ? "index" : "search_results";
    const remoteBottomNav = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: `/BottomNavMobile/Flights/${pageRole === "index" ? "Index" : "SearchResults"}`,
        type: "capla"
    }, {
        fallbackComponent: () => null
    });
    if (!isMobile || isWebview || !BOTTOM_NAV_PAGE_LIST.includes(routeName)) {
        return null;
    }
    const { Component } = remoteBottomNav;
    return React.createElement(Component, null);
}
